// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountDetail_account-detail__jrY-S .AccountDetail_image__luray {
  margin-bottom: 20px;
}
.AccountDetail_account-detail__jrY-S .AccountDetail_image__luray img {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountDetail/AccountDetail.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AACI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AACN","sourcesContent":[".account-detail {\n  .image {\n    margin-bottom: 20px;\n    img {\n      width: 100px;\n      height: 100px;\n      border-radius: 10px;\n      object-fit: cover;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account-detail": `AccountDetail_account-detail__jrY-S`,
	"image": `AccountDetail_image__luray`
};
export default ___CSS_LOADER_EXPORT___;
